// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"8b6864c6","667":"fb1a8243","977":"e15f659f"}[chunkId] + ".chunk.js";
};